import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { LocationIcon } from './Icons';
import './Coverage.css';

const Coverage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const regions = [
    { name: t.redSeaState },
    { name: t.khartoumState }, 
    { name: t.northDarfurState },
    { name: t.gedarefState },
    { name: t.blueNileState },
    { name: t.whiteNileState },
    { name: t.sennarState }
  ];

  return (
    <section id="coverage" className="coverage">
      <div className="container">
        <div className="section-header">
          <h2>{t.geographicCoverage}</h2>
          <p>{t.coverageIntro}</p>
        </div>
        
        <div className="coverage-content">
          <h3>{t.currentOperations}</h3>
          <p>{t.coverageText}</p>
          
          <div className="regions-grid">
            {regions.map((region, index) => (
              <div key={index} className="region-card">
                <div className="region-icon">
                  <LocationIcon />
                </div>
                <h4>{region.name}</h4>
              </div>
            ))}
          </div>
        </div>

        <div className="national-reach">
          <h3>{t.nationalReach}</h3>
          <p>{t.nationalReachDesc}</p>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
